import { useQuery } from '@tanstack/react-query';

import { fetchNHDFindings } from '@/services/api/nhd';
import { NHDFindings } from '@/types/NHD';

export interface UseNHDFindingsResult {
  data: NHDFindings | null;
  isLoading: boolean;
}

export function useNHDFindings(propertyId: string | undefined): UseNHDFindingsResult {
  const { data, isLoading } = useQuery({
    queryKey: ['nhd', propertyId],
    queryFn: () => fetchNHDFindings(propertyId ?? ''),
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });

  return { data: data ?? null, isLoading };
}
